var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.rm
    ? _c(
        "div",
        [
          _c("CriterionDetailsDialog", {
            attrs: { viewModel: _vm.criterionDetailsDialog },
          }),
          _vm._v(" "),
          _c("AlternativeDetailsDialog", {
            attrs: { viewModel: _vm.alternativeDetailsDialog },
          }),
          _vm._v(" "),
          _vm.rm.AlternativeId
            ? _c("MeetingQuestionReviewDr", {
                attrs: {
                  propIsMeetingManager: _vm.isMeetingManager,
                  propContextName: _vm.contextName,
                  propValue: _vm.value,
                  propComment: _vm.comment,
                  propVotesEntries: _vm.votesEntries,
                  propAlternativeName: _vm.alternativeName,
                  propScaleLevels: _vm.scaleLevels,
                },
                on: {
                  "show-alternative-details": _vm.showAlternativeDetails,
                  "show-criterion-details": _vm.showCriterionDetails,
                  "update-vote-value": _vm.updateVoteValue,
                  "update-vote-comment": _vm.updateVoteComment,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.rm.AlternativeId
            ? _c("MeetingQuestionReviewPc", {
                attrs: {
                  propIsMeetingManager: _vm.isMeetingManager,
                  propContextName: _vm.contextName,
                  propValue: _vm.value,
                  propComment: _vm.comment,
                  propVotesEntries: _vm.votesEntries,
                  propFirstAlternativeName: _vm.firstAlternativeName,
                  propSecondAlternativeName: _vm.secondAlternativeName,
                },
                on: {
                  "show-first-alternative-details":
                    _vm.showFirstAlternativeDetails,
                  "show-second-alternative-details":
                    _vm.showSecondAlternativeDetails,
                  "show-criterion-details": _vm.showCriterionDetails,
                  "update-vote-value": _vm.updateVoteValue,
                  "update-vote-comment": _vm.updateVoteComment,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }